import React, { memo, useCallback, useState, useEffect } from 'react';
import styles from './Discount.module.less';
import KeepAlive, { useAliveController, useActivate } from 'react-activation';
import RouteTabs from '../../components/RouteTabs/RouteTabs';
import { Switch, Route, useHistory, useRouteMatch, Redirect, useLocation } from 'react-router-dom';
import DiscountRecommend from './DiscountRecommend/DiscountRecommend';
import DiscountRank from './DiscountRank/DiscountRank';
import { DISCOUNT_TABSMAP } from '../../constants/discount';
import { CONTEXT } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import { logPostInfo, logging } from '../../actions/log';
import { createSelector } from 'reselect';

import { getQueryString } from '../../utils/utils';
import { getDiscountRankMenu, handleTpye, handleOrder } from '../../actions/discount';

let interval = null;

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function Discount() {
  const { url } = useRouteMatch();
  const { drop, dropScope, refresh } = useAliveController();
  const history = useHistory();
  const loaction = useLocation();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    if (loaction?.search) {
      const tag = getQueryString('tag', loaction?.search);
      history.push(`${url}/${tag}`);
    }
  }, [loaction]);

  const handleDeleteALive = useCallback((current, path) => {
    dropScope(current);
    // 点击菜单 为了删除缓存drop(current)生效，所以setTimeout之后在push页面
    if (window.location.pathname !== path) {
      setTimeout(() => {
        history.push(path);
      }, 50);
    }
  }, []);

  const handleChangeTabs = useCallback(
    (item, isClickTabs = true) => {
      if (activeTab === item.key) {
        return;
      }
      // document.getElementById('RouteTabs').style.paddingBottom = 0;
      setActiveTab(() => item.key);
      isClickTabs && handleDeleteALive(item.aliveName, item.path);
      // dispatch(
      //   logging({
      //     category: 'P',
      //     action: item.logPageKey,
      //     param2: {
      //       source: item.logPageKey,
      //       source_p: logInfoData.source,
      //     },
      //   }),
      // );
      if (item.logPageKey === 'Sales_Rank') {
        dispatch(handleTpye(null));
        dispatch(handleOrder(null));
      }
    },
    [activeTab],
  );

  useEffect(() => {
    const item = DISCOUNT_TABSMAP.find(item => item.path === location.pathname);
    if (!item) return;
    handleChangeTabs(item, false);
  }, [location.pathname]);

  return (
    <div className={`${styles.Discount} ${styles.main_page_content}`}>
      <RouteTabs
        tabsList={DISCOUNT_TABSMAP}
        activeTab={activeTab}
        handleChangeTabs={handleChangeTabs}
      />
      <Switch>
        <Route exact path={`${url}/recommend`}>
          <DiscountRecommend />
        </Route>
        <Route exact path={`${url}/rank`}>
          <DiscountRank />
        </Route>
        <Redirect to={`${CONTEXT}/discount/recommend`} />
      </Switch>
    </div>
  );
}

export default () => (
  <KeepAlive name="discount">
    <Discount />
  </KeepAlive>
);
